angular.element(document.body).ready(function() {
  angular.bootstrap(document.body, ['rings-app']);
});


angular.module('rings-app', [
  // services
  'loginService',
  'usersService',
  'ringsService',
  'codebookService',
  'locationService',
  'familyService',
  'observationService',
  'rasService',
  'mailService',
  'exportService',
  // constants
  'constants',
  //'rings-app.delay',            // delays every HTTP request - for testing only
  'rings-app.directives',
  'rings-app.form.helpers',
  'rings-app.directives.user',
  'rings-app.directives.admin',
  'rings-app.directives.foreign',
  'rings-app.directives.recovery',
  'rings-app.releasenotes',
  // different app sections
  'rings-app.home',
  'rings-app.pages',
  'rings-app.register',
  'rings-app.error',
  // components
  'rings-translate',              // translate
  'chart.js',                     // chart
  //'chartjs-directive',            // chart
  'ngAnimate',                    // animations using animate.css
  'ngMessages',                   // ng messages to validate form
  //'uiGmapgoogle-maps',          // google maps API
  //'ngMap',
  // leaflet
  'nemLogging',
  'ui-leaflet',
  'angucomplete-alt',             // angular autocomplete
  'angularUtils.directives.dirPagination', // angular pagination
  'ui.bootstrap',                 // angular bootstrap directives
  'angularBootstrapNavTree',      // nav tree
  'angularMoment',                // moment js for angular
  'ngSanitize',                   // for ngCsv
  'ngCsv',                        // export to Csv
  'ngFileUpload',                 // upload files
  'ngCookies',                    // cookie Store
  'angular-clipboard',            // copy to clipboard
])
.config(function ($urlRouterProvider) {
  $urlRouterProvider.otherwise('/');
})
.config(function($translateProvider){
  $translateProvider.useSanitizeValueStrategy('escape');
})
.config(['$compileProvider',
    function ($compileProvider) {
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|file|blob):/);
}])
/*.config(['$provide', function($provide) {
     var DEFAULT_TIMEZONE = 'GMT';

     $provide.decorator('dateFilter', ['$delegate', '$injector', function($delegate, $injector) {
       var oldDelegate = $delegate;

       var standardDateFilterInterceptor = function(date, format, timezone) {
         if(angular.isUndefined(timezone)) {
           timezone = DEFAULT_TIMEZONE;
         }
         return oldDelegate.apply(this, [date, format, timezone]);
       };

       return standardDateFilterInterceptor;
     }]);
}])*/
/*
* filter only unique values in an array
*/
.filter('unique', function() {
    return function (arr, field) {
        return _.uniq(arr, function(a) { return a[field]; });
    };
})
/*display number of days in format y m d*/
.filter('duration',function(){
  return function(input){
    var out = '';
    var years = Math.floor(input/365);
    var months = Math.floor((input - years*365)/30);
    var days = input - years*365 - months*30;
    // if there is only one, display the number
    if (years >= 5){
      out += years.toString() + ' let ';
    } else if (years >= 2){
      out += years.toString() + ' roky ';
    } else if (years == 1){
      out += '1 rok ';
    }
    if (months >= 5){
      out += months.toString() + ' měsíců ';
    } else if (months >= 2){
      out += months.toString() + ' měsíce ';
    } else if (months == 1){
      out += '1 měsíc ';
    }
     if (days >= 5){
      out += days.toString() + ' dní';
    } else if (days >= 2){
      out += days.toString() + ' dny'
    } else if (days == 1){
      out += '1 den';
    }
    return out;
  };
})
.filter('species',function($filter){
  return function(input){
    if (input) {
      return input;
    } else {
      return 'neznámý druh';
    }
  }
})
.filter('familyrole',function($filter){
  return function(input){
    if ( input === 'sibling' ) {
      return "sourozenec";
    } else if ( input === 'parent' ) {
      return 'rodič';
    } else {
      return null;
    }
  }
})
.filter('ringnumber',function($filter){
  return function(input){
    var regex = /^([1-9]{0,1}[a-zA-Z]+)0*([1-9][0-9]*)$/i;     
    var match = regex.exec(input);
    if (match != null){
      return match[1] + ' ' + match[2]
    } else {
      return input
    }
  }
})
// filter for latitude
.filter('latitude',function($filter){
  return function(input,digits){
    var out = '';
    out += $filter('number')(input,digits);
    if (input < 0){
      out += 'S'
    } else {
      out += 'N'
    }
    return out;
  }
})
// filter - show km after distance
.filter('distance',function($filter){
  return function(input){
    if (input){
      return input + ' km';
    } else {
      return input;
    }
    
  }
})
// filter - show circle after direction
.filter('direction',function($filter){
  return function(input){
     if (input){
      return input + ' °';
    } else {
      return input;
    }
  }
})
// filter for longitude
.filter('longitude',function($filter){
  return function(input,digits){
    var out = '';
    out += $filter('number')(input,digits);
    if (input < 0){
      out += 'W'
    } else {
      out += 'E'
    }
    return out;
  }
})
// filter for coordinates - output in euring format
.filter('crds',function(){
  return function(lat,lng){
    var out = '';
    // latitude
    var dglat = Math.floor(lat);
    var minlat1 = (lat - dglat)*60;
    var minlat2 = Math.floor(minlat1);
    var seclat = Math.floor((minlat1 - minlat2)*60)
     // longitude
    var dglng = Math.floor(lng);
    var minlng1 = (lng - dglng)*60;
    var minlng2 = Math.floor(minlng1);
    var seclng = Math.floor((minlng1 - minlng2)*60)
    // add up
    out = '+'+("0" + dglat).slice(-2)+("0" + minlat2).slice(-2)+("0" + seclat).slice(-2);
    out += '+'+("00" + dglng).slice(-3)+("0" + minlng2).slice(-2)+("0" + seclng).slice(-2);
    return out;
  }
})
// filter for coordinates - Czechia
.filter('crdsdeg',function(){
  return function(lat,lng,zeroes){
    var out = '';
    // latitude
    var dglat = (lat < 0) ? Math.ceil(lat) : Math.floor(lat);
    var minlat1 = (lat - dglat)*60;
    var minlat2 = (lat < 0) ? Math.ceil(minlat1) : Math.floor(minlat1);
    var seclat = (lat < 0) ? Math.ceil((minlat1 - minlat2)*60) : Math.floor((minlat1 - minlat2)*60)
     // longitude
    var dglng = (lng < 0) ? Math.ceil(lng) : Math.floor(lng);
    var minlng1 = (lng - dglng)*60;
    var minlng2 = (lng < 0) ? Math.ceil(minlng1) : Math.floor(minlng1);
    var seclng = (lng < 0) ? Math.ceil((minlng1 - minlng2)*60) : Math.floor((minlng1 - minlng2)*60)
    // add up
    if (dglat >0) {
      out = 'N';
    } else {
      out = 'S';
      dglat = Math.abs(dglat);
    }
    if (zeroes) {
      out += ("0" + dglat).slice(-2)+'°'+("0" + minlat2).slice(-2)+'\''+ ("0" + seclat).slice(-2)+'\'\'\t';
      if (dglng > 0) {
        out += 'E';
      } else {
        out += 'W';
        dglng = Math.abs(dglng);
      }
      out += ("00" + dglng).slice(-3)+'°'+("0" + minlng2).slice(-2)+'\'' + ("0" + seclng).slice(-2)+'\'\'';
    } else {
      out += dglat+'°'+("0" + minlat2).slice(-2)+'\''+("0" + seclat).slice(-2)+'\'\'\t';
      if (dglng > 0) {
        out += 'E';
      } else {
        out += 'W';
        dglng = Math.abs(dglng);
      }
      out += dglng+'°'+("0" + minlng2).slice(-2)+'\''+("0" + seclng).slice(-2)+'\'\'';
    }
    return out;
  }
})
// filter for coordinates - report species Slovakia
.filter('crdsdegsk',function(){
  return function(lat,lng){
    var out = '';
    // latitude
    var dglat = (lat < 0) ? Math.ceil(lat) : Math.floor(lat);
    var minlat1 = (lat - dglat)*60;
    var minlat2 = (lat < 0) ? Math.ceil(minlat1) : Math.floor(minlat1);
     // longitude
    var dglng = (lng < 0) ? Math.ceil(lng) : Math.floor(lng);
    var minlng1 = (lng - dglng)*60;
    var minlng2 = (lng < 0) ? Math.ceil(minlng1) : Math.floor(minlng1);
    // add up
    if (dglat >0) {
      out = 'N';
    } else {
      out = 'S';
      dglat = Math.abs(dglat);
    }
    out += dglat+'°'+("0" + minlat2).slice(-2)+'\'\t';
    if (dglng > 0) {
      out += 'E';
    } else {
      out += 'W';
      dglng = Math.abs(dglng);
    }
    out += dglng+'°'+("0" + minlng2).slice(-2)+'\'';
    return out;
  }
})
// filter get hour from string HH:MM:SS
.filter('hour', function(){
  return function(input){
    if (input === null || input.length < 8){
      return '';
    } else if (input == '00:00:00'){
      return '';
    } else {
      return input.replace(':','').substring(0,4);
    }
  }
})
// filter for phone number
.filter('tel',function(){
  return function(input){
    
    if (!input) return null;

    switch(input.length){
      case 4:
        return '('+input+')';
      case 9:
        return input.slice(0,3)+' '+input.slice(3,6)+' '+input.slice(6,9)
      case 13:
        return '('+input.slice(0,4)+') '+input.slice(4,7)+' '+input.slice(7,10)+' '+input.slice(10,13)
      default:
        return input; 
    }
  }
})
.filter("localeOrderBy", [function () {
        return function (array, sortPredicate, reverseOrder) {
            if (!Array.isArray(array)) return array;
            if (!sortPredicate) return array;
 
            var isString = function (value) {
                return (typeof value === "string");
            };
 
            var isNumber = function (value) {
                return (typeof value === "number");
            };
 
            var isBoolean = function (value) {
                return (typeof value === "boolean");
            };
 
            var arrayCopy = [];
            angular.forEach(array, function (item) {
                arrayCopy.push(item);
            });
 
            arrayCopy.sort(function (a, b) {
                var valueA = a[sortPredicate];
                var valueB = b[sortPredicate];
                if (!valueB){
                  valueB = '';
                }
 
                if (isString(valueA))
                    return !reverseOrder ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
 
                if (isNumber(valueA) || isBoolean(valueA))
                    return !reverseOrder ? valueA - valueB : valueB - valueA;
 
                return 0;
            });
 
            return arrayCopy;
        }
    }])
.run(function ($rootScope, $window, amMoment,$location,$uibModal, usersService) {
  // google analytics
  $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams) {
    var realURL = toState.url;
    if (!!$window.ga) {
      // resolves variables inside urls, ex: /error/:error in /error/unauthorized
      for (var v in toParams) {
        realURL = realURL.replace(':' + v, toParams[v]);
      }
      $window.ga('send', 'pageview', realURL);
    }
  });

  // change moment locale to cs (moment js to parse time and date)
  amMoment.changeLocale('cz');
  
  /**
   * $rootScope.doingResolve is a flag useful to display a spinner on changing states.
   * Some states may require remote data so it will take awhile to load.
   * Local doing resolve is used to display spinner when inner states are changed
   */
  
  /*
  * global resolve is used, if there is refresh, or user navigates to one of main pages from another main page
  */
  var useGlobalResolve = function(fromState, toState) {
    if (fromState.name.length == 0) {   // refresh of page -- no from page
      return true;
    } else {
      var basePageFrom = fromState.name.split('.')[1]   // example: app.admin.users => admin
      var basePageTo = toState.name.split('.')[1]       // example: app.user.home => user
      if (basePageFrom != basePageTo) {
        return true;                    // navigating between main pages -- resolve main
      }
    }
    return false;                       // if conditions were not met, do not resolve main
  }

  /*
  * resolving finished
  */
  var resolveDone = function () {       // both local and global are resolved
    $rootScope.doingResolve = false; 
    $rootScope.localDoingResolve = false;

    // confirm 
    if ($rootScope.user.rings.InstructionsRead === 0) {
      console.log("instructions not read")
      var modalInstance = $uibModal.open({
      //template: '<information-confirmation-modal-window></information-confirmation-modal-window>',
        templateUrl: 'myModalContent.html',
      controller: 'informationConfirmationModalWindow',
      size: "md",
      resolve: {
        items: function () {
          //console.log("a")
          //return $scope.items;
        }
      }
    });

    modalInstance.result.then(function () {
      // TODO SAVE
      var body = {UID: $rootScope.user.UID, InstructionsRead:1}
      usersService.updateRingsUser(body).then(
        function(data) {
          //console.log(data)
        });
      //console.log("close")
    }, function () {
      //console.log('dismissed');
    });
      
    } 
  };

  /*
  * default value - not doing resolve
  */
  $rootScope.doingResolve = false;
  $rootScope.localDoingResolve = false;

  /*
  * when the state is changed, resolve always local, and check, if global should be resolved
  */
  $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
    $rootScope.localDoingResolve = true;
    $rootScope.doingResolve = useGlobalResolve(fromState, toState);
  });
  $rootScope.$on('$stateChangeSuccess', resolveDone);
  $rootScope.$on('$stateChangeError', resolveDone);
  $rootScope.$on('$statePermissionError', resolveDone);
})
/*
* main controller
*/
.controller('BodyController', function ($scope, $state, $stateParams, loginService, $http, $timeout, $rootScope, $translate, myConfig, $window) {

  var browser = $window.navigator.userAgent;
  $scope.mozilla = browser.indexOf('Mozilla') != -1;
  $scope.ie = browser.indexOf('MSIE') != -1;

  // Expose $state and $stateParams to the <body> tag
  $scope.$state = $state;
  $scope.$stateParams = $stateParams;

  //$scope.prodDb = (myConfig.apiUrl === 'http://ringsapi.birds.cz/v1/');
  $scope.prodDb = true;

  // loginService exposed and a new Object containing login user/pwd
  $scope.ls = loginService;
  $rootScope.ls = $scope.ls;
  $scope.login = {
    working: false,
    wrong: false
  };

  // todo - cookies - ukladat localizaci
  $scope.czPath = '/img/cz.png';
  $scope.enPath = '/img/en_gs.png';

  $scope.showLicenceNumber = function(){
    return ($scope.user && $scope.user.rings && $scope.user.rings.LicenceNumber);
  };
  
  $scope.changeLanguage = function(lang){
    switch(lang){
      case 'cz':
        $translate.use('cz');
        $scope.czPath = '/img/cz.png';
        $scope.enPath = '/img/en_gs.png';
        break;
      case 'en':
        $translate.use('en');
        $scope.czPath = '/img/cz_gs.png';
        $scope.enPath = '/img/en.png';
        break;
    }
  }
  
  // login user
  $scope.loginMe = function () {

    var string = $scope.login.username + ":" + $scope.login.password;
    var encodedString = btoa(encodeURI(string));

    var loginPromise = $http({
         method  :'GET',
         url: myConfig.apiUrl + 'login?project=rings', //'http://127.0.0.1:8000/v1/login?project=rings',
         withCredentials: true,
         headers :{'authorization':'Basic ' + encodedString}
            });

    $scope.login.working = true;
    $scope.login.wrong = false;

    loginService.loginUser(loginPromise);
    loginPromise.error(function () {
      $scope.login.wrong = true;
      $timeout(function () { $scope.login.wrong = false; }, 8000);
    });
    loginPromise.finally(function () {
      $scope.login.working = false;
      $rootScope.user = $scope.user;
      //console.log($rootScope.user);
      // TEST Slovensko
      //$rootScope.user.rings.scheme = 'SKB'
      // redirect user to observation page, admin to admin home
      if (typeof($scope.user.rings) !== 'undefined'){
        switch($scope.user.rings.title){
          case "user":
            $state.go('app.user.observation');
            break;
          case "admin":
            $state.go('app.admin.retraps');
            break;
          case "olddata":
            $state.go('app.user.olddata');
            break;
        }
      } 
      
    });
  };
  // logout user
  $scope.logoutMe = function () {
    var userToken = localStorage.getItem('userToken');
    var logoutPromise = $http({
         method  :'GET',
         url: myConfig.apiUrl + 'logout', //'http://127.0.0.1:8000/v1/logout',
         withCredentials: true,
         headers :{'authorization':'Basic ' + userToken}
            });

    loginService.logoutUser(logoutPromise);
  };
})
.controller('informationConfirmationModalWindow',['$rootScope','$uibModalInstance'
  ,function($rootScope,$uibModalInstance){
  $rootScope.test = function() {return("ABS")}

  $rootScope.ok = function () {
    $uibModalInstance.close('close');
  };

  $rootScope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
}])